import React, { useEffect, useState } from "react";
import { DashboardBudgetSection } from "./DashboardBudgetSection";
import { DashboardSavingSection } from "./DashboardSavingSection";
import { DashboardGoalSection } from "./DashboardGoalSection";
import dashboradReportIcon from "../../assets/images/bank.png";
import restIcon from "../../assets/images/budget/restWhite.svg";
import editIcon from "../../assets/images/budget/pencil-square.svg";
import swal from "sweetalert";
import { Icon } from "antd";

import FETCH from "../../utils/fetch";
import DEATH_API from "../../apis/death.api";
import axios from "axios";
import "./mainDashboard.css";
import { Alert, Select, Spin } from "antd";
import { DashboardGoalCharts } from "./DashboardGoalCharts";
import { DatePicker } from "antd";
import { Modal } from "antd";
import moment from "moment";
import { MODULE_API } from "../../apis";
import { BudgetExpanse } from "./BudgetExpanse";
import { TopMonthlyExpanse } from "./TopMonthlyExpanse";
import { GoalProgress } from "./GoalProgress";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { CustomSkeleton } from "./CustomSkeleton";
import DashboardCalendar from "../../components/newly-components/DashboardCalendar";
import { NetWorthBudgetGraph } from "../../components/newly-components/NetWorthBudgetGraph";
import ChatComponentDashboard from "../../components/newly-components/ChatComponentDashboard";
import InvestmentWatchlistTable from "../../components/newly-components/MainDashboardAssetTables";
import StoredDocumentsTable from "../../components/newly-components/StoredDocumentsTable";
import PortfolioBalancesTable from "../../components/newly-components/PortfolioBalancesTable";
import UpcomingBillsTable from "../../components/newly-components/UpcomingBillsTable";
import DashboardSavingsGoal from "../../components/newly-components/CircularBarFillComponent";
import { IncomeAndExpensChart } from "../../components/newly-components/IncomeAndExpensChart";
import LatestNews from "../../components/newly-components/LatestNews";
import TasksList from "../../components/newly-components/Tasklist";
import TwitterFeeds from "../../components/newly-components/TwitterFeeds";
import { DashboardGeneralSection } from "./DashboardGeneralSection";
import RecurringBillsTable from "../../components/newly-components/RecurringBillsTable";
import { useTheme } from "../../utils/ThemeContext";
import NotFoundTile from "../../components/newly-components/NotFoundTile";
import { useHistory } from "react-router-dom";
import MiniCalendar from "../../components/newly-components/MiniCalendar";

const { Option } = Select;

export const SavedDashboard3 = ({
  setSaveTilesLoading,
  saveTilesLoading,
  callState,
  dragButtonVisible,
  setDragButtonVisible,
}) => {
  const { theme } = useTheme();

  const [loading, setLoading] = useState(false);
  const [dragLoading, setDragLoading] = useState(false);
  const [totalLoan, setTotalLoan] = useState(0);
  const [totalBalance, setTotalBalance] = useState(0);
  const [assetsAmount, setAssetsAmount] = useState(0);
  const [reportData, setReportData] = useState(null);
  const [editBalance, setEditBalance] = useState(false);
  const [monetaryValue, setMonetaryValue] = useState(0);
  const [debtValue, setDebtValue] = useState(0);
  const [availablebalance, setAvailablebalance] = useState(0);
  const [openNotificationContainer, setOpenNotificationContainer] =
    useState(true);
  const [collectiblesList, setCollectiblesList] = useState([]);
  const [inventoryList, setInventoryList] = useState([]);

  const [allExpanse, setAllExpanse] = useState([]);
  const [topExpanse, setTopExpanse] = useState([]);
  const [budgets, setBudgets] = useState([]);
  const [goals, setGoals] = useState([]);
  const [goalsData, setGoalsData] = useState([]);
  const [assetsToselect, setAssetsToSelect] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [selectedAssets, setSelectedAssets] = useState([]);
  const [selectedUserAssets, setSelectedUserAssets] = useState([]);
  const [originalSetting, setOriginalSetting] = useState([]);
  const [currentModuleType, setCurrentModuleType] = useState("Asset");
  const [updateTime, setUpdateTime] = useState(null);
  const [components, setComponents] = useState([]);
  const history = useHistory();
  const [nextLocation, setNextLocation] = useState(null);
  const availablePermissions =
    localStorage.getItem("permissionState") != "undefined" &&
    JSON.parse(localStorage.getItem("permissionState") || null);

  const { MonthPicker } = DatePicker;
  const getCollectiblesList = async (isAppending = false) => {
    try {
      setLoading(true);
      let datares = await DEATH_API.getCollectableValues();
      if (datares && datares.message) {
        const mappedRecords = datares.message.map((item, idx) => ({
          ...item,
          module: "Collectible",
          "Name of Asset": item.sub_type,
          image: item.image || "https://assets-planet.s3.amazonaws.com/media/189a1487-e5d8-4a1f-8af5-e29026efc77f.png",
          "Account Type/Titled": "Collectible",
          "Held Where": null,
          "Monetary Value": item.monetary,
          "Value as of Date": null,
          id: item.id || `collectible_${idx}`,
        }));
        setCollectiblesList(mappedRecords);
        setAssetsToSelect((prevAssets) =>
          isAppending ? [...prevAssets, ...mappedRecords] : mappedRecords,
        );
        return mappedRecords;
      }
      setLoading(false);
      return [];
    } catch (error) {
      console.log(error);
      setLoading(false);
      return [];
    }
  };

  const getInventoryList = async (page = 1, isAppending = false) => {
    try {
      setLoading(true);
      const userRole =
        localStorage.getItem("role") != "undefined" &&
        JSON.parse(localStorage.getItem("role"));
      const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id:
          userRole === "Financial Advisor Client"
            ? `?module=PROPERTY&page=${page}&limit=10&clientId=${ID}`
            : `?module=PROPERTY&page=${page}&limit=10`,
        body: {},
      });
      if (datares && datares.records) {
        const mappedRecords = datares.records.map((item, idx) => ({
          ...item,
          "Name of Asset": item.name,
          image: item.image || "https://assets-planet.s3.amazonaws.com/media/421ecad8-a621-4e8e-a678-67a0e7d3572f.png",
          "Account Type/Titled": item.module,
          "Held Where": item.city,
          "Monetary Value": item.total,
          id: item.id || `inventory_${idx}`,
        }));
        setInventoryList(mappedRecords);
        setAssetsToSelect((prevAssets) =>
          isAppending ? [...prevAssets, ...mappedRecords] : mappedRecords,
        );

        if (datares.pagination) {
          const { limit, total } = datares.pagination;
          setHasMore(page * limit < total);
        } else {
          setHasMore(false);
        }
        return mappedRecords;
      } else {
        setHasMore(false);
        return [];
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      return [];
    }
  };

  const handleMonthChange = (date, dateString) => {
    if (date) {
      const startDate = date.startOf("month").format("YYYY-MM-DD"); // Start of the month
      const endDate = date.endOf("month").format("YYYY-MM-DD");
      console.log("Start Date of the Month:", startDate);
      console.log("End Date of the Month:", endDate);
      // resetState();
      callFilter(startDate, endDate);
    }
  };

  const callFilter = async (startDate, endDate) => {
    const collectibles = await getCollectiblesList();
    const inventory = await getInventoryList(1, false);

    if (
      localStorage.getItem("setting") != "undefined" &&
      JSON.parse(localStorage.getItem("setting"))
    ) {
      await updateUserSetting(collectibles, inventory);
    } else {
      await getUserRole(collectibles, inventory);
    }
    setAssetsToSelect([]);
    setPage(1);
    setCurrentModuleType("Asset");
    await getAssetsList(1, false, "Asset");
    // await getMonetaryValue(startDate);
    await getDebt(startDate, endDate);
    await getBudgets(startDate, endDate);
    await getGoals(startDate, endDate);
    await getGoalsList();
    // await getTopExpanse(startDate, endDate);
    await getExpanse(startDate, endDate);
  };

  const updateUserAssetAvailable = async () => {
    try {
      setLoading(true);
      const allPossibleAssets = [...assetsToselect, ...selectedUserAssets];
      const filteredAssets = allPossibleAssets
        .filter((asset, index, self) =>
          selectedAssets.includes(asset.id) &&
          self.findIndex(a => a.id === asset.id) === index
        )
        .map((asset) => ({
          id: asset.id,
          "Name of Asset": asset["Name of Asset"],
        }));

      console.log(
        "filteredAssets",
        filteredAssets,
        selectedAssets,
      );
      setSelectedUserAssets(filteredAssets);
      const date = new Date();
      setUpdateTime(date);
      let payload = {
        ...originalSetting,
        dashboard3DragCards: components,
        assets: filteredAssets,
        updatedDate: new Date(),
      };

      console.log("payload1111", payload);
      let data = await DEATH_API.updateUserAssetSetting(payload);
      if (data && data.status === 200) {
        const date = moment();
        const startDate = date.startOf("month").format("YYYY-MM-DD");
        await getSeletedAssetsMonetaryValue(startDate, selectedAssets);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleDeleteAsset = async (assetId) => {
    try {
      setLoading(true);
      const updatedAssets = selectedUserAssets.filter((item) => item.id !== assetId);
      const updatedAssetIds = updatedAssets.map((item) => item.id);

      setSelectedUserAssets(updatedAssets);

      const date = moment();
      const startDate = date.startOf("month").format("YYYY-MM-DD");

      let payload = {
        ...originalSetting,
        dashboard3DragCards: components,
        assets: updatedAssets,
        updatedDate: new Date(),
      };

      let data = await DEATH_API.updateUserAssetSetting(payload);
      if (data && data.status === 200) {
        await getSeletedAssetsMonetaryValue(startDate, updatedAssetIds);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const updateUserDragCards = async () => {
    try {
      setLoading(true);
      setDragLoading(true);
      let payload = {
        ...originalSetting,
        dashboard3DragCards: components,
        assets: selectedUserAssets,
        updatedDate: new Date(),
      };
      console.log("payload2222", payload);

      const res = await DEATH_API.updateUserAssetSetting(payload);
      if (res && res.status === 200) {
        await getUserRole();
        swal({
          title: "Dashboard Saved",
          text: "Your tile locations have been saved.",
          icon: "success",
        });
      }
      setLoading(false);
      setDragLoading(false);
      setDragButtonVisible(false);
    } catch (error) {
      setLoading(false);
      setDragLoading(false);
      setDragButtonVisible(false);
      console.log(error);
    }
  };
  const getUserRole = async (collectibles, inventory) => {
    try {
      setSaveTilesLoading(true);
      setDragButtonVisible(false);

      let data = await DEATH_API.getUpdatedRole();
      if (data && data.data && data.data.setting) {
        localStorage.setItem("setting", JSON.stringify(data.data.setting));
        setOriginalSetting(data.data.setting);
        if (data.data.setting.assets) {
          let assets = data.data.setting.assets;
          const assetIds = assets.map((asset) => asset.id);
          setSelectedUserAssets(data.data.setting.assets);
          const date = moment();
          const startDate = date.startOf("month").format("YYYY-MM-DD");
          if (assetIds && assetIds.length > 0) {
            await getSeletedAssetsMonetaryValue(startDate, assetIds, collectibles, inventory);
          }
        }
        if (data.data.setting.updatedDate) {
          setUpdateTime(data.data.setting.updatedDate);
        }
        if (
          data.data.setting.dashboard3DragCards &&
          data.data.setting.dashboard3DragCards.length > 0
        ) {
          setComponents(data.data.setting.dashboard3DragCards);
        } else {
          setComponents([{ id: "TileNotFound" }]);
        }
      } else {
        setComponents([{ id: "TileNotFound" }]);
      }

      setSaveTilesLoading(false);
    } catch (error) {
      setSaveTilesLoading(false);

      console.log(error);
    }
  };
  const updateUserSetting = async (collectibles, inventory) => {
    try {
      // setLoading(false);
      setSaveTilesLoading(true);
      setDragButtonVisible(false);
      const settings =
        localStorage.getItem("setting") != "undefined" &&
        JSON.parse(localStorage.getItem("setting") || null);
      if (settings) {
        setOriginalSetting(settings);
        if (settings.assets) {
          let assets = settings.assets;
          const assetIds = assets.map((asset) => asset.id);
          setSelectedUserAssets(settings.assets);
          const date = moment();
          const startDate = date.startOf("month").format("YYYY-MM-DD");
          if (assetIds && assetIds.length > 0) {
            await getSeletedAssetsMonetaryValue(startDate, assetIds, collectibles, inventory);
          }
        }
        if (settings.updatedDate) {
          setUpdateTime(settings.updatedDate);
        }
        if (
          settings.dashboard3DragCards &&
          settings.dashboard3DragCards.length > 0
        ) {
          setComponents(settings.dashboard3DragCards);
        } else {
          setComponents([{ id: "TileNotFound" }]);
        }
      } else {
        setComponents([{ id: "TileNotFound" }]);
      }

      // setLoading(false);
      setSaveTilesLoading(false);
    } catch (error) {
      // setLoading(false);
      setSaveTilesLoading(false);
      console.log(error);
    }
  };

  const permissionMap = {
    budgetExpanse: ["Budget Dashboard Data", "Super Admin"],
    topMonthlyExpanse: ["Get Budget", "Super Admin"],
    dashboardBudgetSection: ["Get Budget", "Super Admin"],
    dashboardSavingSection: ["Get Budget", "Super Admin"],
    goalProgress: ["FetchGoalsDetail", "Super Admin"],
    dashboardGoalCharts: ["Super Admin", "Total Monthaly Saving"],
    ChatComponentDashboard: ["chat count", "Super Admin"],
    MiniCalendar: ["GetGoogleAuth", "Super Admin"],
    IncomeAndExpensChart: ["Super Admin", "income vs expense"],
    TwitterFeeds: ["Super Admin"],
    PortfolioBalancesTable: ["Store Account Details", "Super Admin"],
    UpcomingBillsTable: ["Fetch Bills to Pay", "Super Admin"],
    LatestNews: ["Fetch News", "Super Admin"],
    TasksList: ["GetGoogleAuth", "Super Admin"],
    DashboardCalendar: ["GetGoogleAuth", "Super Admin"],
    dashboardGoalSection: ["FetchGoalsDetail", "Super Admin"],
    DashboardSavingsGoal: ["FetchGoalsDetail", "Super Admin"],
    InvestmentWatchlistTable: ["Super Admin"],
    StoredDocumentsTable: ["Fetch Client Death Documents", "Super Admin"],
    RecurringBillsTable: ["Get Budget", "Super Admin"],
    generalMain: ["Super Admin", "create client module"],
    // ... map all components to required permission keys
  };

  const renderComponent = (componentId) => {
    switch (componentId) {
      case "TileNotFound":
        return <NotFoundTile />;
      case "budgetExpanse":
        return (
          <BudgetExpanse
            data={budgets && budgets}
            loading={loading}
            getAllBudgets={getBudgets}
          />
        );
      case "dashboardBudgetSection":
        return (
          <DashboardBudgetSection
            monetary={availablebalance}
            data={assetsAmount}
            totalLoan={totalLoan}
            debt={debtValue && debtValue}
            totalBalance={totalBalance}
            reportData={reportData}
            loading={loading}
            getNetWorth={getMonetaryValue}
          />
        );
      case "dashboardSavingSection":
        return (
          <DashboardSavingSection
            expenseData={allExpanse && allExpanse}
            loading={loading}
            getAllExpanse={getExpanse}
            getAllTopExpanse={getTopExpanse}
          />
        );
      case "topMonthlyExpanse":
        return (
          <TopMonthlyExpanse
            plaidData={topExpanse && topExpanse}
            originalSetting={originalSetting && originalSetting}
            loading={loading}
            getTopExpanse={getTopExpanse}
          />
        );
      case "goalProgress":
        return (
          <GoalProgress
            goalsData={goals && goals}
            loading={loading}
            getAllGoals={getGoals}
          />
        );
      // case "dashboardGoalCharts":
      //   return (
      //     <DashboardGoalCharts goalsData={goals && goals} loading={loading} />
      //   );
      // case "NetWorthBudgetGraph":
      //   return <NetWorthBudgetGraph />;
      case "dashboardGoalCharts":
        return (
          <NetWorthBudgetGraph
            goalsData={goalsData && goalsData}
            loading={loading}
          />
        );
      case "ChatComponentDashboard":
        return <ChatComponentDashboard />;
      case "MiniCalendar":
        return <MiniCalendar />;
      case "IncomeAndExpensChart":
        return <IncomeAndExpensChart />;
      case "TwitterFeeds":
        return <TwitterFeeds />;
      case "PortfolioBalancesTable":
        return <PortfolioBalancesTable />;
      case "UpcomingBillsTable":
        return <UpcomingBillsTable />;
      case "LatestNews":
        return <LatestNews />;
      case "TasksList":
        return <TasksList />;
      case "DashboardCalendar":
        return <DashboardCalendar />;
      case "dashboardGoalSection":
        return (
          <DashboardGoalSection
            goalsData={goalsData && goalsData}
            loading={loading}
          />
        );
      case "DashboardSavingsGoal":
        return <DashboardSavingsGoal />;
      case "InvestmentWatchlistTable":
        return <InvestmentWatchlistTable />;
      case "StoredDocumentsTable":
        return <StoredDocumentsTable />;
      case "RecurringBillsTable":
        return <RecurringBillsTable />;
      case "generalMain":
        return (
          <div style={{}}>
            <h3
              style={{
                color: theme === "light" ? "#232323" : "white",
              }}
            >
              Account Balance
            </h3>
            <div className="generalMain">
              <div
                className="reportCard1"
                style={{ display: "flex", width: "30%" }}
              >
                <div
                  className="generalMaincards"
                  style={{
                    background: "transparent",
                    width: "100%",
                    color: "white",
                    flexWrap: "nowrap",
                    height: "65%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "start",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      className="generalMaincardsInner"
                      style={{ flexWrap: "nowrap", color: "white" }}
                    >
                      {" "}
                      <div
                        className="generalMainImages"
                        style={{ padding: "10px" }}
                      >
                        <img
                          src={dashboradReportIcon}
                          height={"44px"}
                          alt={"balance"}
                        />{" "}
                      </div>
                    </div>
                    <div>
                      <div className="generalCardAssetsContainer">
                        <div className="generalMainHeader">
                          <span className="gerealheading">
                            Available Balance:
                          </span>
                          {/*  <span
                  className="gerealheadingValue"
                  style={{ color: "white" }}
                >
                  ${" "}
                  {23234.56 &&
                    (23234.56)
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                </span> */}
                        </div>
                        {localStorage.getItem('role') && JSON.parse(localStorage.getItem('role')) !== "Financial Advisor Client" && (<div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "8px",
                          }}
                        >
                          <img
                            src={editIcon}
                            width={24}
                            alt={"edit"}
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setSelectedAssets(selectedUserAssets.map(a => a.id));
                              setEditBalance(true);
                            }}
                          />
                          <img
                            style={{ cursor: "pointer" }}
                            src={restIcon}
                            alt="reset"
                          />
                        </div>)}
                      </div>
                      <span
                        className="gerealheadingValue"
                        style={{ color: "white" }}
                      >
                        ${" "}
                        {availablebalance &&
                          availablebalance
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      </span>
                    </div>
                  </div>

                  <div
                    className="custom-scrollbar-asset"
                    style={{
                      marginTop: "1rem",
                      overflowY: "auto",
                      // height: "3rem",
                      height: "97%",
                    }}
                  >
                    {selectedUserAssets &&
                      selectedUserAssets.map((item, index) => (
                        <div key={index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                          <span>{item["Name of Asset"] ? item["Name of Asset"] : ""}</span>
                          <Icon type="delete" color={"white"} style={{ cursor: "pointer" }} onClick={() => handleDeleteAsset(item.id)} />
                        </div>
                      ))}
                  </div>
                  <div
                    style={{
                      marginTop: "1rem",
                      display: "flex",
                      justifyContent: "end",
                      color: "rgb(163, 174, 208)",
                    }}
                  >
                    <div>
                      {updateTime &&
                        `Updated at: ${updateTime &&
                        moment(updateTime)
                          .local()
                          .format("MM/DD/YYYY [at] hh:mmA")
                        }`}
                    </div>
                  </div>
                </div>
              </div>

              <DashboardGeneralSection
                monetary={availablebalance && availablebalance}
                debt={debtValue && debtValue}
                data={assetsAmount && assetsAmount}
                totalLoan={totalLoan && totalLoan}
                totalBalance={totalBalance && totalBalance}
                loading={loading}
              />
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  useEffect(() => {
    if (callState) {
      const collectibles = (collectiblesList && collectiblesList.length > 0) ? collectiblesList : null;
      const inventory = (inventoryList && inventoryList.length > 0) ? inventoryList : null;
      getUserRole(collectibles, inventory);
    }
  }, [callState]);

  //
  //
  //
  //
  //
  //

  const getMonetaryValue = async (date) => {
    try {
      setLoading(true);
      setMonetaryValue(0);
      let data = await MODULE_API.getMonetaryValue(date);
      if (data && data.total && data.total[0] && data.total[0].monetary) {
        setMonetaryValue(data.total[0].monetary);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const getDebt = async (startDate, endDate) => {
    try {
      setLoading(true);
      setDebtValue(0);
      let data = await MODULE_API.getDebt(startDate, endDate);
      if (data && data.data) {
        setDebtValue(data.data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const getSeletedAssetsMonetaryValue = async (date, assetsData, collectibles, inventory) => {
    try {
      setLoading(true);
      setAvailablebalance(0);
      console.log("assetsData", assetsData);

      const numericIds = (assetsData || []).filter(id => !isNaN(id) && typeof id === 'number');
      let totalMonetary = 0;

      if (numericIds.length > 0) {
        let payload = {
          clientModuleIds: numericIds,
        };
        let data = await MODULE_API.getSelectedMonetaryValue(date, payload);
        if (data && data.total && data.total[0] && data.total[0].monetary) {
          totalMonetary = data.total[0].monetary;
        }
      }

      // Calculate remaining values on frontend for non-numeric IDs (like collectibles fallback)
      const selectedItems = assetsToselect && assetsToselect.length > 0 ? assetsToselect : (selectedUserAssets || []);
      const additionalSum = (assetsData || []).reduce((sum, id) => {
        if (isNaN(id) || typeof id !== 'number') {
          let item = selectedItems.find(a => a.id === id);

          if (!item && typeof id === 'string') {
            if (id.startsWith('collectible_')) {
              item = (collectibles || collectiblesList || []).find(c => c.id === id);
            } else if (id.startsWith('inventory_')) {
              item = (inventory || inventoryList || []).find(i => i.id === id);
            }
          }

          const val = item ? (item["Monetary Value"] || item.monetary || item.total) : 0;
          return sum + (parseFloat(val) || 0);
        }
        return sum;
      }, 0);

      setAvailablebalance(totalMonetary + additionalSum);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const handleSave = async () => {
    setEditBalance(false);
    await updateUserAssetAvailable();
    setSelectedAssets([]);
  };
  const handleCancel = () => {
    setSelectedAssets([]);
    setEditBalance(false);
  };
  const getBudgets = async (startDate, endDate) => {
    try {
      setLoading(true);
      setBudgets([]);
      let data = await MODULE_API.getFilterBudgets(startDate, endDate);
      if (data && data.data) {
        setBudgets(data.data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const getGoals = async (startDate, endDate) => {
    try {
      setLoading(true);
      setGoals([]);
      let data = await MODULE_API.getFilterGoals(startDate, endDate);
      if (data && data.data) {
        setGoals(data.data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const getGoalsList = async () => {
    try {
      setLoading(true);
      const userRole =
        localStorage.getItem("role") != "undefined" &&
        JSON.parse(localStorage.getItem("role"));
      const ID = localStorage.getItem("accessId");
      let response = await FETCH.post({
        url: "client-module-service/client-module/list",
        id:
          userRole === "Financial Advisor Client"
            ? `?module=Goals&page=1&limit=100&clientId=${ID}`
            : `?module=Goals&page=1&limit=100`,
        body: {},
      });
      if (response && response.records) {
        setGoalsData(response.records);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getExpanse = async (startDate, endDate) => {
    try {
      setLoading(true);
      setAllExpanse([]);
      let data = await MODULE_API.getTransactionExpanses(startDate, endDate);
      if (data && data.data) {
        setAllExpanse(data.data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const getTopExpanse = async (startDate, endDate) => {
    try {
      setLoading(true);
      setTopExpanse([]);
      let data = await MODULE_API.getTopExpanses(startDate, endDate);
      if (data && data.data) {
        setTopExpanse(data.data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const resetState = () => {
    setAllExpanse([]);
    setTopExpanse([]);
    setMonetaryValue(0);
    setBudgets([]);
    setGoals([]);
  };
  useEffect(() => {
    const date = moment();
    const startDate = date.startOf("month").format("YYYY-MM-DD");
    const endDate = date.endOf("month").format("YYYY-MM-DD");
    callFilter(startDate, endDate);
  }, []);

  const getAssetsList = async (pageNum = 1, isAppending = false, moduleName = "Asset") => {
    try {
      setLoading(true);
      const userRole =
        localStorage.getItem("role") != "undefined" &&
        JSON.parse(localStorage.getItem("role"));
      const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: `client-module-service/client-module/list`,
        id:
          userRole === "Financial Advisor Client"
            ? `?module=${moduleName}&page=${pageNum}&limit=10&clientId=${ID}`
            : `?module=${moduleName}&page=${pageNum}&limit=10`,
        body: {},
      });

      if (datares && datares.records) {
        const mappedRecords = datares.records.map((item) => ({
          ...item,
          "Name of Asset": item.name || item["Name of Asset"],
          "Account Type/Titled": item.module || item["Account Type/Titled"],
          "Held Where": item.city || item["Held Where"],
          "Monetary Value": item.total || item["Monetary Value"],
        }));
        setAssetsToSelect((prevAssets) =>
          isAppending ? [...prevAssets, ...mappedRecords] : mappedRecords,
        );

        if (datares.pagination) {
          const { limit, total } = datares.pagination;
          setHasMore(pageNum * limit < total);
        } else {
          setHasMore(false);
        }
      } else {
        setHasMore(false);
      }

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const handlePopupScroll = (e) => {
    const { target } = e;
    if (loading) return;

    if (target.scrollTop + target.offsetHeight >= target.scrollHeight) {
      if (hasMore) {
        const nextPage = page + 1;
        setPage(nextPage);
        if (currentModuleType === "Asset") {
          getAssetsList(nextPage, true, "Asset");
        } else if (currentModuleType === "PROPERTY") {
          getInventoryList(nextPage, true);
        }
      } else {
        if (currentModuleType === "Asset") {
          setCurrentModuleType("PROPERTY");
          setPage(1);
          getInventoryList(1, true);
        } else if (currentModuleType === "PROPERTY") {
          setCurrentModuleType("Collectible");
          getCollectiblesList(true);
        }
      }
    }
  };

  useEffect(() => {
    const unblock = history.block((location, action) => {
      if (dragButtonVisible) {
        setNextLocation(location);

        swal({
          title: "Are you sure?",
          text: "Changes have not been saved. Are you sure you want to leave?",
          icon: "warning",
          dangerMode: true,
          buttons: ["Yes", "No"],
          closeOnConfirm: false,
          closeOnCancel: false,
        }).then((isConfirm) => {
          if (isConfirm) {
            return null;
          } else {
            setDragButtonVisible(false);
            history.push(location.pathname);
          }
        });

        return false;
      }
      return true;
    });

    return () => {
      unblock();
    };
  }, [dragButtonVisible, history, nextLocation]);

  const onDragEnd = (result) => {
    const { source, destination } = result;

    if (components.length > 1) {
      setDragButtonVisible(true);
    }

    if (!destination) return;

    const updatedComponents = Array.from(components);
    const [movedComponent] = updatedComponents.splice(source.index, 1);
    updatedComponents.splice(destination.index, 0, movedComponent);

    setComponents(updatedComponents);
  };

  return (
    <>
      <div>
        <Modal visible={editBalance} footer={null} closable={false} centered>
          <h3 className="modaltitle">Edit Available Balance</h3>
          <h3 className="modaltitle" style={{ fontSize: "14px" }}>
            Select Assets to Calculate Available Balance
          </h3>
          <h3 className="inputTitle">All Assets</h3>
          <Select
            mode="multiple"
            showSearch
            style={{ width: "100%" }}
            placeholder="Select Assets"
            onPopupScroll={handlePopupScroll} // Pagination on scroll
            value={selectedAssets && selectedAssets}
            onChange={(value) => {
              console.log("value", value);
              setSelectedAssets(value);
            }}
            notFoundContent={loading ? <Spin /> : null}
            optionLabelProp="label"
          >
            {assetsToselect &&
              assetsToselect.map((asset, index) => (
                <Option
                  key={index}
                  value={asset["Name of Asset"]}
                  label={asset["Name of Asset"]}
                >
                  <span
                    role="img"
                    aria-label={asset["Name of Asset"]}
                    style={{ marginRight: "8px" }}
                  >
                    <img
                      width={32}
                      src={asset.image}
                      alt={asset["Name of Asset"]}
                    ></img>
                  </span>
                  {asset["Name of Asset"]}
                </Option>
              ))}
          </Select>
          <div className="buttonsMain">
            <button
              className="cancelbutton"
              onClick={() => {
                handleCancel();
              }}
            >
              Cancel
            </button>
            <button
              className="savebutton"
              onClick={() => {
                handleSave();
              }}
            >
              Save
            </button>
          </div>
        </Modal>

        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <button
            disabled={!dragButtonVisible}
            className="savebutton"
            style={{
              marginTop: "10px",
              backgroundColor: !dragButtonVisible
                ? "#6c757d"
                : "rgb(42, 61, 163)",
            }}
            onClick={() => {
              updateUserDragCards();
            }}
          >
            Save Dashboard Setting
          </button>
          {loading && dragLoading ? (
            <Spin style={{ marginTop: "18px" }} />
          ) : null}
        </div>
        <div className="SavedDashboard12" style={{ marginTop: "1rem" }}>
          {saveTilesLoading || (components && components.length === 0) ? (
            <CustomSkeleton />
          ) : (
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="dashboard" direction="vertical">
                {(provided) => (
                  <div {...provided.droppableProps} ref={provided.innerRef}>
                    {/* Flex container for non-full-width components with gap */}
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "1rem", // Adding gap of 1rem between flex items
                      }}
                    >
                      {components.map((component, index) => {
                        const isFullWidthComponent = [
                          "DashboardSavingsGoal",
                          "DashboardCalendar",
                          "generalMain",
                          "TileNotFound",
                        ].includes(component.id);
                        const requiredPermissions =
                          permissionMap[component.id] || [];
                        const hasPermission =
                          availablePermissions &&
                          requiredPermissions.some((permission) =>
                            availablePermissions.includes(permission)
                          );
                        if (component.id === 'RecurringBillsTable' || component.id === 'PortfolioBalancesTable') return;

                        return (
                          <Draggable
                            key={component.id}
                            draggableId={component.id}
                            index={index}
                          >
                            {(provided, snapshot) => {
                              const isDragging = snapshot.isDragging;

                              return (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  style={{
                                    ...provided.draggableProps.style,
                                    width: isFullWidthComponent
                                      ? "100%"
                                      : "49%",
                                    background: "white",
                                    flexWrap: "nowrap",
                                    borderRadius: "16px",
                                    opacity: hasPermission ? 1 : 0.5,
                                    cursor: hasPermission
                                      ? "default"
                                      : "not-allowed",
                                    pointerEvents: hasPermission
                                      ? "auto"
                                      : "none",
                                    backgroundColor:
                                      theme === "dark"
                                        ? component.id !== "generalMain" &&
                                        "#232323"
                                        : "white",
                                    padding: "1rem",
                                    marginBottom: "1rem",
                                    ...(isDragging && {
                                      width:
                                        provided.draggableProps.style.width ||
                                        (isFullWidthComponent
                                          ? "100%"
                                          : "100%"),
                                    }),
                                    ...(isFullWidthComponent
                                      ? {}
                                      : {
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        flexWrap: "nowrap",
                                      }),
                                  }}
                                >
                                  {renderComponent(component.id)}
                                </div>
                              );
                            }}
                          </Draggable>
                        );
                      })}
                    </div>
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          )}
        </div>
      </div>
    </>
  );
};
